/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { DunaRedirectTokenResponseDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class DunaApplicationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags duna-application-controller
   * @name InitiateOnboardingAndReturnToken
   * @request POST:/api/v1/duna/application
   */
  initiateOnboardingAndReturnToken = (params: RequestParams = {}) =>
    this.http.request<DunaRedirectTokenResponseDto, any>({
      path: `/v1/duna/application`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static initiateOnboardingAndReturnTokenPath = '/v1/duna/application'
  static initiateOnboardingAndReturnTokenMethod = 'POST'
  /**
   * No description
   *
   * @tags duna-application-controller
   * @name ShouldRedirectToDuna
   * @request GET:/api/v1/duna/application/shouldRedirect
   */
  shouldRedirectToDuna = (params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/v1/duna/application/shouldRedirect`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static shouldRedirectToDunaPath = '/v1/duna/application/shouldRedirect'
  static shouldRedirectToDunaMethod = 'GET'
}
